<!--
 * @Author: wangyan1 wangyan1
 * @Date: 2023-10-19 14:27:58
 * @LastEditors: wangyan1 wangyan1
 * @LastEditTime: 2023-11-13 18:09:37
 * @FilePath: /teacher-xkh-web/src/components/InJzxTool/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%A
-->
<template>
  <div class="injzx-tool">
    <div v-if="visible" class="injzx-box" ref="injzxTool">
      <a-spin class="injzx-tool-con" :spinning="spinning" />
    </div>
  </div>
</template>
<script>
import PostmateHandler, { EVENT, CONFIG } from '@/utils/Postmate'
import storage from '@/utils/storage.js'
import { removeToken } from '@/utils/tools.js'
import { message } from 'ant-design-vue'

const pageMap = {
  url1: 'xkh/studentDetails',
  url2: 'beike/bk',
  url3: 'teaching/index',
  url4: 'questiondetail',
  url5: 'xkh/studentReport'
}
export default {
  props: {
    pageType: {
      // 1: 学生讲次列表
      type: Number,
      default: 0
    },
    pageParams: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      visible: true,
      postMate: null,
      selfPageType: 0,
      spinning: true,
      UUId: Math.random()
        .toString(36)
        .substring(2, 12)
    }
  },
  methods: {
    frameSrc() {
      this.selfPageType = this.$route.query.pageType
      let query = this.jsonToUrlParams(this.$route.query || {})
      if (!this.selfPageType) {
        this.selfPageType = this.pageType
        query = this.jsonToUrlParams(this.pageParams || {})
      }
      return `${process.env.VUE_APP_JZX_TEACHER}/${pageMap['url' + this.selfPageType]}?t=${new Date().getTime()}&${query}`
    },
    initFrame() {
      const frameUrl = this.frameSrc()
      // const iframe = document.createElement('iframe');
      // iframe.setAttribute('allowfullscreen', '');
      this.postMate = new PostmateHandler({
        container: this.$refs.injzxTool,
        url: frameUrl,
        name: 'my-iframe-name-' + this.UUId,
        model: {
          allow: 'fullscreen',
          platform: CONFIG.platform
        },
        classListArray: ['frame-container', 'frame-container-' + this.UUId]
      })
      console.log('frameUrl==>postMate ', this.postMate)
      this.postMate.handshake.then(() => {
        console.log('parent handshake success')
        document.documentElement.querySelector('.frame-container-' + this.UUId).style.display = 'block'
        this.spinning = false
      })
      this.postMate.onMessage(EVENT.GET_PLATFORM, msg => {
        this.postMate.sendMessage(EVENT.PLATFORM_RESULT, {
          platform: CONFIG.platform
        })
        setTimeout(() => {
          const frame = document.documentElement.querySelector('.frame-container-' + this.UUId)
          frame.style.display = 'block'
          this.spinning = false
        }, 1000)
      })
      this.postMate.onMessage(EVENT.OPEN_PAGE, msg => {
        if (!msg || !msg.scene) {
          console.log('OPEN_PAGE msg.scene is null', msg)
          return
        }
        // 精准学学生批改页面
        if (msg.scene === 100) {
          const { href } = this.$router.resolve({
            name: 'inJzxCommonPage',
            query: {
              pageType: 4,
              ...(msg.params || {})
            }
          })
          window.open(href, '_blank')
        } else if (msg.scene === 101) {
          this.$emit('event-handle', {
            type: EVENT.OPEN_PAGE,
            msg
          })
        } else if (msg.scene === 102) {
          // 监课跳转学员详情
          this.$router.push({
            name: 'InJzxSecondPagePage',
            query: {
              pageType: 4,
              ...(msg.params || {})
            }
          })
        }
      })
      this.postMate.onMessage(EVENT.CLOSE_PAGE, msg => {
        console.log('授课页', EVENT.CLOSE_PAGE)
        if (!msg || !msg.scene) {
          console.log('CLOSE_PAGE msg.scene is null', msg)
          return
        }
        if (msg.scene === 100) {
          this.$emit('event-handle', {
            type: EVENT.CLOSE_PAGE,
            msg
          })
        }
      })
      this.postMate.onMessage(EVENT.LOGOUT, ({ errMsg }) => {
        errMsg && message.error(errMsg)
        storage.remove('ptxkhtpc')
        removeToken()
        setTimeout(() => {
          this.$router.replace({
            name: 'login'
          })
        }, 500)
      })
    },
    jsonToUrlParams(json) {
      console.log('jsonToUrlParams', json)
      return Object.keys(json).map(k => `${k}=${json[k]}`).join('&')
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initFrame()
    })
  },
  beforeDestroy() {
    this.postMate && this.postMate.destroy()
    this.visible = false
  }
}
</script>
<style lang="less">
.injzx-tool-con {
  width: 25px;
  height: 25px;
}
.injzx-tool {
  // display: flex;
  // justify-content: center;
  // align-items: center;
  width: 100%;
  height: 100%;
}
.injzx-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.frame-container {
  background-color: rgba(0, 0, 0, 0);
  display: none;
  width: 100%;
  height: 100%;
}
</style>
